<script lang="ts">
export default {
  name: 'KkMore',
}
</script>

<script lang="ts" setup>
import { ref, computed } from 'vue'
import DOMPurify from 'dompurify'
import { syntaxHighlight } from '../../../modules/syntaxHighlight'
import { searchQueryAnalyzer } from '../../../modules/searchQueryAnalyzer'

export interface Props {
  text: string
  length?: number
  keyword?: string
  isExpandHtml?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  text: '',
  length: 100,
  isExpandHtml: true,
})

const isDisplayedAllText = ref(false)

if (props.keyword) isDisplayedAllText.value = true

const textLength = computed(() => {
  return props.text.length
})

const isVisibleMoreTrigger = computed(() => {
  return !isDisplayedAllText.value && textLength.value > props.length
})

const isVisibleCloseTrigger = computed(() => {
  return isDisplayedAllText.value && textLength.value > props.length
})

const displayText = computed(() => {
  const text = DOMPurify.sanitize(props.text)
  if (props.keyword) {
    return syntaxHighlight(text, searchQueryAnalyzer(props.keyword), 'c-more__highlight')
  } else {
    return isDisplayedAllText.value ? text : text.substring(0, props.length)
  }
})

const showAllText = () => {
  isDisplayedAllText.value = true
}

const shortText = () => {
  isDisplayedAllText.value = false
}
</script>

<template>
  <div>
    <span v-if="props.isExpandHtml" v-html="displayText" />
    <span v-else>{{ displayText }}</span>
    <template v-if="!keyword">
      <span v-show="isVisibleMoreTrigger" class="c-more__trigger">...<button type="button" @click="showAllText"><strong>{{ $t('labels.showMore') }}</strong></button></span>
      <span v-show="isVisibleCloseTrigger" class="c-more__trigger"><button type="button" @click="shortText"><strong>{{ $t('labels.close') }}</strong></button></span>
    </template>
  </div>
</template>
